module.exports = __webpack_public_path__ + "images/feature/20150709_03-17829006620843ced8ee12610aee02ec.png";